export default __webpack_public_path__ + "static/media/player-circle.0f57bcaf.svg";